var _clipPath, _rect, _g, _path, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0V15H70V30H60zM0,30V40H30V0H60z"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Niue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 60,
    fill: "#002868"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#cf142b",
    strokeWidth: 6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L60,30M60,0L0,30",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0L60,30M60,0L0,30",
    clipPath: "url(#t)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0V40M0,15H70",
    stroke: "#fff",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,0V40M0,15H70"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60,0h60V60H0V30H60z",
    fill: "#fcd116"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30,15)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.10390485)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 1,
    fill: "#002868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M0,-513674 301930,415571 -488533,-158734H488533L-301930,415571",
    fill: "#fcd116",
    transform: "scale(0.00000194676)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(-17.5,0.29) scale(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(17.5,0.29) scale(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(0,10.29) scale(3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s",
    transform: "translate(0,-9.71) scale(3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.62d2f1f712a04ceee5cefa2977a93e04.svg";
export { ForwardRef as ReactComponent };